module.exports = __webpack_public_path__ + "static/logo_wes_white-3f5b591df7c0e6892cda6cf2e417c128.svg";